import styled from "@emotion/styled";
import { Alert, Box, Pagination, Skeleton } from "@mui/material";

export const Page = styled.main(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.secondary,
	minHeight: "calc(100vh - 72px)",
	paddingBottom: "32px"
}));

export const Header = styled.header(({ theme }) => ({
	background: `linear-gradient(100deg, ${theme.project.colors.primaryColors.main}, ${theme.project.colors.allColors.hex.blue.cwg.cwgBlue200} 60%, ${theme.project.colors.allColors.hex.grayscale.white50})`,
	color: theme.project.colors.allColors.hex.grayscale.white50,
	padding: "18px clamp(20px, 4vw, 48px)"
}));

export const Heading = styled.h1({
	fontSize: "30px",
	fontWeight: 400,
	lineHeight: 1.2,
	margin: 0
});

export const Content = styled.div({
	boxSizing: "border-box",
	marginTop: "14px",
	padding: "0 clamp(16px, 3vw, 32px)",
	width: "100%"
});

export const Articles = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "10px"
});

export const ArticleButton = styled.button(({ theme }) => ({
	alignItems: "stretch",
	backgroundColor: theme.project.colors.allColors.hex.grayscale.white50,
	border: `1px solid ${theme.project.colors.allColors.hex.grayscale.gray300}`,
	color: "inherit",
	cursor: "pointer",
	display: "grid",
	font: "inherit",
	gridTemplateColumns: "96px minmax(0, 1fr) 44px",
	minHeight: "78px",
	overflow: "hidden",
	padding: 0,
	textAlign: "left",
	textDecoration: "none",
	transition: "border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease",
	width: "100%",
	"&:hover": {
		borderColor: theme.project.colors.primaryColors.main,
		boxShadow: "0 3px 12px rgba(0, 0, 0, 0.08)",
		transform: "translateY(-1px)"
	},
	"&:focus-visible": {
		outline: `3px solid ${theme.project.colors.allColors.hex.blue.cwg.cwgBlue300}`,
		outlineOffset: "2px"
	},
	[theme.breakpoints.down("sm")]: {
		gridTemplateColumns: "76px minmax(0, 1fr) 36px",
		minHeight: "86px"
	}
}));

export const Thumbnail = styled.img(({ theme }) => ({
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray200,
	height: "100%",
	minHeight: "78px",
	objectFit: "cover",
	width: "96px",
	[theme.breakpoints.down("sm")]: {
		minHeight: "86px",
		width: "76px"
	}
}));

export const ArticleCopy = styled.div({
	alignSelf: "center",
	minWidth: 0,
	padding: "12px 16px"
});

export const ArticleTitle = styled.h2(({ theme }) => ({
	color: theme.project.colors.fontColors.main,
	fontSize: "14px",
	fontWeight: 500,
	lineHeight: "157%",
	margin: "0 0 3px",
	letterSpacing: "0.1px"
}));

export const ArticleSubtitle = styled.p(({ theme }) => ({
	color: theme.project.colors.fontColors.secondary,
	fontSize: "14px",
	fontWeight: 400,
	lineHeight: "143%",
	letterSpacing: "0.17px",
	margin: 0,
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
	[theme.breakpoints.down("sm")]: {
		display: "-webkit-box",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 2,
		whiteSpace: "normal"
	}
}));

export const Chevron = styled.span(({ theme }) => ({
	alignItems: "center",
	color: theme.project.colors.fontColors.secondary,
	display: "flex",
	fontSize: "24px",
	justifyContent: "center"
}));

export const PaginationContainer = styled(Box)({
	display: "flex",
	justifyContent: "center",
	paddingTop: "20px"
});

export const PagePagination = styled(Pagination)(({ theme }) => ({
	"& .MuiPaginationItem-page:not(.Mui-selected)": {
		...theme.project.typography.body.body2,
		color: theme.project.colors.fontColors.main
	},
	"& .MuiPaginationItem-root.Mui-selected": {
		backgroundColor: theme.project.colors.allColors.hex.blue.light.lightBlue500,
		color: theme.project.colors.allColors.hex.grayscale.white50
	}
}));

export const LoadingCard = styled(Skeleton)({
	borderRadius: 0,
	height: "78px",
	transform: "none"
});

export const StateMessage = styled(Alert)({
	marginTop: "16px"
});
